"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.I18nProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const jotai_1 = require("jotai");
const atom_1 = require("../../atom");
const i18next_icu_1 = __importDefault(require("i18next-icu"));
const i18next_1 = require("i18next");
const react_i18next_1 = require("react-i18next");
const I18nProvider = ({ children }) => {
    const { language } = (0, jotai_1.useAtomValue)(atom_1.$Locale);
    const resources = (0, jotai_1.useAtomValue)(atom_1.$I18nText);
    const i18n = (0, react_1.useMemo)(() => {
        const _i18n = (0, i18next_1.createInstance)({
            lng: language,
            resources,
            returnNull: false,
        });
        _i18n.use(react_i18next_1.initReactI18next);
        _i18n.use(i18next_icu_1.default);
        _i18n.init().catch(() => void 0);
        if (__BUILD_TARGET__ === 'client') {
            window.i18next = _i18n;
        }
        return _i18n;
    }, []);
    return (0, jsx_runtime_1.jsx)(react_i18next_1.I18nextProvider, { i18n: i18n, children: children });
};
exports.I18nProvider = I18nProvider;
